import sortable from './sortable';

export const handleMultiDeselect = (
  deselecteds,
  nameField,
  selectedOptions,
  setSelectedOptions,
  data,
  setData
) => {
  const options = selectedOptions[nameField].slice();
  deselecteds.forEach(option => options.splice(options.indexOf(option), 1));
  setSelectedOptions({ ...selectedOptions, [nameField]: options });
  const values = options.map(opt => opt.value);
  setData({ ...data, [nameField]: values });
};

export const handleMultiSelect = (
  selecteds,
  nameField,
  selectedOptions,
  setSelectedOptions,
  data,
  setData
) => {
  const options = selecteds.slice();
  options.sort(sortable);
  setSelectedOptions({ ...selectedOptions, [nameField]: options });
  const values = options.map(opt => opt.value);
  setData({ ...data, [nameField]: values });
};
